module.exports = __webpack_public_path__ + "img/youtube.86997cba.svg";